import { createAction } from "redux-actions";
import * as ActionTypes from "../../../actionTypes";
import { userAccessTokenSelector } from "../../../security";
import WorkFlowController from "../../../services/workflowController";

const workflowController = new WorkFlowController();

export const printReportRequested: Action = createAction(
  ActionTypes.PRINT_REPORT_REQUESTED
);

export const printReportReceived: Action = createAction(
  ActionTypes.PRINT_REPORT_RECEIVED
);

export const printReportFailed: Action = createAction(
  ActionTypes.PRINT_REPORT_FAILED
);

const printPerSuiteEnergyReportAPI = async (data, options) =>
  await workflowController.printPerSuiteEnergyReport(data, options);
export const printPerSuiteEnergyReport = (
  locationId,
  group,
  dateFrom,
  dateTo,
  buildingId
) => async (dispatch, getState) => {
  dispatch(printReportRequested());
  try {
    await printPerSuiteEnergyReportAPI(
      { locationId, group, dateFrom, dateTo, buildingId },
      { token: userAccessTokenSelector(getState()) }
    );
    dispatch(printReportReceived());
  } catch (err) {
    // handles network errors
    console.log(err);
    dispatch(
      printReportFailed(
        "There was a problem printing Energy Consumption Report."
      )
    );
  }
};

const printCopCalculationReportAPI = async (data, options) =>
  await workflowController.printCopCalculationReport(data, options);
export const printCopCalculationReport = (
  locationId,
  dateFrom,
  dateTo
) => async (dispatch, getState) => {
  dispatch(printReportRequested());
  try {
    await printCopCalculationReportAPI(
      { locationId, dateFrom, dateTo },
      { token: userAccessTokenSelector(getState()) }
    );
    dispatch(printReportReceived());
  } catch (err) {
    // handles network errors
    console.log(err);
    dispatch(
      printReportFailed("There was a problem printing Cop Calculation Report.")
    );
  }
};



// WEBPACK FOOTER //
// ./src/features/report/store/reportActions.js